import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {CmsBannerId} from '../../services/cms/cms-banners/cm-banner-id/cms-banner-id';
import {observer} from 'mobx-react';
import {EmptyBannerDefinition} from '../../services/cms/cms-banners/banner-definition/empty-banner-definition';
import {IBannerDefinition} from '../../services/cms/cms-banners/banner-definition/banner-definition.interface';
import {BannerContainerBox} from "./banner-container/banner-container.box";

export interface CmsBannerComponentProps {
    componentID: string;
    templateID: string;
    fallbackComponent: string;
    showPlaceholder: boolean;
    className?: string;
    minHeight?: string;
}

@observer
export class CmsBannerComponent extends OrbitComponent<CmsBannerComponentProps> {
    componentDidMount() {
        super.componentDidMount();
        this.services.cmsBanners.loadBanner(this._bannerId);
    }

    componentDidUpdate() {
        this.services.cmsBanners.loadBanner(this._bannerId);
    }

    private get _bannerId(): CmsBannerId {
        return new CmsBannerId(this.props.componentID, this.props.templateID, this.props.fallbackComponent);
    }

    private get _bannerDefinition(): IBannerDefinition {
        let contentDefinition = this.services.cmsBanners.bannersMap[this._bannerId.key];
        if (contentDefinition) {
            return contentDefinition;
        }

        return new EmptyBannerDefinition();
    }

    render() {

        return (
            <BannerContainerBox minHeight={this.props.minHeight}
                                className={`cy-cms-banner-container tcmid-${this._bannerId.componentID} ${this.props.className || ''}`}>
                {
                    this._bannerDefinition.render({
                        showPlaceholder: this.props.showPlaceholder,
                        minHeight: this.props.minHeight
                    })
                }
            </BannerContainerBox>
        );
    }
}